import React from "react"
import { RouteComponentProps } from "@reach/router"
import _ from "lodash"
import toggles from 'feature-toggles'
import Subnav from "components/subnav"
import { Container_s, Content_s } from "styles/app-styles"
import propertyAssetService from 'data/property-asset'
import propertyService from "data/property"
import { local } from 'data/lib/local-json'

type Route = {
  name: string
  link: string
}
type PropertyState = {
  tabs: Route[]
  currentasset: number | null | undefined
}
class Property extends React.Component<RouteComponentProps, PropertyState> {
  assetSubscription: any = null
  propertySubscription: any = null
  constructor(props) {
    super(props)
    this.state = {
      tabs: [],
      currentasset: null
    }
  }

  getTabs() {
    const propertyType = local('property_type', null);
    toggles.get().then(() => {
      const propertySettingsTab = toggles.displayAssetManagement() ? [{link: '/n/property/settings', name: 'Property Settings', hard: false}] : [{link: '/property/settings', name: 'Property Settings', hard: true}]
      const valuationSettingsTab = toggles.displayValuationSettings() ? [{name: "Valuation Settings", link: "/n/property/valuation-settings"}] : []
      let areaMeasuresTab = _.includes(["Multifamily", "Hospitality"], propertyType) ? [{link: '/n/property/area-measure', name: 'Area Measures'}] : [{link: '/property/area-measure', name: 'Area Measures', hard: true}]
      if (propertyType !== "Multifamily" && toggles.displayNewTenantMarket()){
        areaMeasuresTab = [{link: '/n/property/area-measure', name: 'Area Measures'}]
      }
      // const assetAttributesTab = {link: '/n/property/asset-attributes', name: 'Asset Attributes'}
      let defaultsTab = propertyType === "Hospitality" ? [] : [{link: '/n/property/defaults', name: 'Defaults'}]
      const auditLogTab =  toggles.displayOldPropertyAuditLog() ? [{name: "Audit Log", link: "/property/audit-log", hard: true}] : [{name: "Audit Log", link: "/n/property/audit-log"}]
      const tabs = [
        ...propertySettingsTab,
        ...valuationSettingsTab,
        ...(this.state.currentasset ? [{name: "Asset Info", link: `/n/property/asset-info/${this.state.currentasset}`}] : []),
        ...areaMeasuresTab,
        ...defaultsTab,
        {link: '/n/property/snapshots', name: 'Snapshots'},
        {link: '/n/property/import-export', name: 'Import/Export'},
        ...auditLogTab
      ]

      // if (toggles.displayAssetManagement() && local('auth.profile')?.assetmanagement) tabs.splice(3, 0, assetAttributesTab)
      this.setState({tabs})
    })
  }

  componentWillMount() {
    this.assetSubscription = propertyAssetService.stream().subscribe(data => {
      this.setState({currentasset: data})
      this.getTabs()
    })
    this.propertySubscription = propertyService.stream().subscribe((data) => {
      if(data.state === "ok") {
        this.getTabs()
      }
    })
    this.setState({currentasset: propertyAssetService.value()})
    this.getTabs()
  }


  componentWillUnmount() {
    this.assetSubscription.unsubscribe()
    this.propertySubscription.unsubscribe()
  }

  render() {
    return (
      <Container_s>
        <Subnav section="PROPERTY" tabs={this.state.tabs}/>
        <Content_s>
          {this.props.children}
        </Content_s>
      </Container_s>
    )
  }
}

export default Property
